import React, { Component, Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";
import { getAllTransactionRedux } from "../../../actions";
import { connect } from "react-redux";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonth: "",
    };
  }

  componentDidMount = async () => {};

  render() {
    return (
      <div className="col-sm-12">
        <div className="card">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ fontWeight: "bold", padding: 10 }}>
              {this.props.month}
            </div>
            <div style={{ marginTop: 5, marginRight: 5 }}>
              <select
                title="Filter by category"
                required
                name="selectedMonth"
                className="custom-select"
                aria-required="true"
                aria-invalid="false"
                onChange={(e) => {
                  this.props.setSelectedMonth(e.target.value);
                }}
                value={this.state.selectedMonth}
              >
                <option value="">Select a Month</option>
                {this.props.monthsArray.map((month) => {
                  return <option value={month}>{month}</option>;
                })}
              </select>
            </div>
          </div>
          <div
            className="card-header"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              overflowX: "scroll",
            }}
          >
            {this.props.product &&
            this.props.product.displayedVariations &&
            this.props.product.displayedVariations.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                {this.props.product.displayedVariations.map((variation) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        padding: 10,
                        border:
                          this.props.variationId == variation.id
                            ? "2px solid darkorange"
                            : "1px solid gainsboro",
                        borderRadius: 10,
                        maxWidth: 100,
                        minWidth: 100,
                        maxHeight: 120,
                        minHeight: 120,
                        overflowY: "scroll",
                        marginLeft: 10,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        this.props.setVariationId(variation.id);
                      }}
                    >
                      <img
                        src={variation.pictures[0] || this.props.productImage}
                        style={{
                          height: 60,
                          width: 60,
                          borderRadius: 5,
                          border: "1px solid gainsboro",
                          marginLeft: 8,
                        }}
                      />
                      <div style={{ textAlign: "center", fontSize: 12 }}>
                        {variation.combination.map((comb) => `${comb.name},`)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <img
                  src={this.props.productImage}
                  style={{
                    height: 100,
                    width: 100,
                    borderRadius: 5,
                    border: "1px solid gainsboro",
                  }}
                />
              </div>
            )}
          </div>

          <div className="card-body">
            <div className="clearfix"></div>
            <div id="basicScenario" className="product-physical row">
              <div className="col" style={{ padding: 0 }}>
                <table
                  className={`table table-bordered table-striped table-hover ${
                    window.innerWidth < 600 ? "table-responsive" : ""
                  }`}
                >
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Purchase Note
                      </th>

                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Total Price/note
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Shipping Charge/Order Status
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Total Cost
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Unit Price
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Purchase Quantity
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Order Id
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Order Status
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Total Bill
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Unit Price
                      </th>

                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Sold Quantity
                      </th>

                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Remaining stock
                      </th>
                      <th
                        scope="col"
                        style={{
                          padding: "30px 15px",
                          color: "white",
                          backgroundColor: "rgb(251, 148, 4)",
                          fontSize: 12,
                        }}
                      >
                        Entry By
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.sortedTransfers.map((transfer, index) => (
                      <tr key={index}>
                        <td>{transfer.date}</td>
                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          {transfer.fundType == "Buying" &&
                            transfer.subCategory}
                        </td>

                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          {transfer.fundType == "Buying"
                            ? transfer.cancelNote
                              ? transfer.cancelNote
                              : transfer.purchasePrice ===
                                "Cancelled by customer"
                              ? transfer.purchasePrice
                              : `${transfer.purchasePrice}Tk`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          {transfer.fundType == "Buying"
                            ? transfer.orderStatus
                              ? transfer.fundType == "Buying" && (
                                  <div
                                    style={{
                                      display: "inline",
                                      backgroundColor:
                                        transfer.orderStatus == "Processing"
                                          ? "#1B75D0"
                                          : transfer.orderStatus == "Confirmed"
                                          ? "orange"
                                          : transfer.orderStatus == "Packing"
                                          ? "darkorange"
                                          : transfer.orderStatus == "Delivered"
                                          ? "green"
                                          : "red",
                                      borderRadius: 7,
                                      border: "1px solid gainsboro",
                                      color: "white",
                                      fontSize: 12,
                                      padding: "2px 5px",
                                    }}
                                  >
                                    {transfer.orderStatus}
                                  </div>
                                )
                              : `${transfer.shippingCharge}Tk`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          {transfer.fundType == "Buying"
                            ? `${transfer.totalCost}Tk`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          {transfer.fundType == "Buying"
                            ? `${transfer.perUnitPrice}Tk`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          {transfer.fundType == "Buying"
                            ? `${transfer.productStock}pc`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "rgb(15 91 151)",
                          }}
                        >
                          {transfer.fundType == "Selling"
                            ? `${transfer.subCategory}`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "rgb(15 91 151)",
                          }}
                        >
                          {transfer.fundType == "Selling" && (
                            <div
                              style={{
                                display: "inline",
                                backgroundColor:
                                  transfer.orderStatus == "Processing"
                                    ? "#1B75D0"
                                    : transfer.orderStatus == "Confirmed"
                                    ? "orange"
                                    : transfer.orderStatus == "Packing"
                                    ? "darkorange"
                                    : transfer.orderStatus == "Delivered"
                                    ? "green"
                                    : "red",
                                borderRadius: 7,
                                border: "1px solid gainsboro",
                                color: "white",
                                fontSize: 12,
                                padding: "2px 5px",
                              }}
                            >
                              {transfer.fundType == "Selling"
                                ? `${transfer.orderStatus}`
                                : ""}{" "}
                            </div>
                          )}
                        </td>

                        <td
                          style={{
                            color: "rgb(15 91 151)",
                          }}
                        >
                          {transfer.fundType == "Selling"
                            ? `${transfer.totalBill}Tk`
                            : ""}
                          <br />
                          {transfer.fundType == "Selling" && transfer.note ? (
                            <span
                              style={{
                                color: "gray",
                                padding: 0,
                                fontSize: 13,
                              }}
                            >
                              {transfer.note}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td
                          style={{
                            color: "rgb(15 91 151)",
                          }}
                        >
                          {transfer.fundType == "Selling"
                            ? `${transfer.perUnitPrice}Tk`
                            : ""}
                        </td>
                        <td
                          style={{
                            color: "rgb(15 91 151)",
                          }}
                        >
                          {transfer.fundType == "Selling"
                            ? `${transfer.sellStock}pc`
                            : ""}
                        </td>

                        <td
                          style={{
                            fontWeight: "bold",
                            color: transfer.fundType ? "darkgreen" : "darkred",
                          }}
                        >
                          {transfer.remainingStock}pc
                        </td>

                        <td style={{ fontWeight: "bold" }}>
                          {transfer.expenseBy}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.products.transactions,
  };
};

export default connect(mapStateToProps, {
  getAllTransactionRedux,
})(MonthlyExpense);
